import { useCallback, useEffect, useMemo, useState } from "react";
import IncidentReportsService from "../../../../../../services/incidentReports";
import { FormInstance } from "antd";
import dayjs from "dayjs";
import { useSelector } from "react-redux";

export const useFetchInfo = (
  type: 1 | 2,
  id: string | undefined | null,
  entryNumber: number | undefined,
  form: FormInstance,
) => {
  const [isLoading, setIsLoading] = useState<boolean>(!!id);

  const [customerId, setCustomerId] = useState<string | undefined>(undefined);

  const user: any = useSelector((state: any) => state.auth.user);

  const initialValues = useMemo(() => {
    const values: any = {
      reporterName: `${user.firstName} ${user.lastName}`,
      customerContractRole: 1,
    };

    if (entryNumber) {
      if (type === 2) {
        values.customerNumber = entryNumber;
      } else {
        values.contractNumber = entryNumber;
      }
    }

    return values;
  }, [user, type, entryNumber]);

  const fetchData = useCallback(async () => {
    try {
      if (id) {
        const data = await IncidentReportsService.fetch(id);

        setCustomerId(data.customerId);

        form.setFieldsValue({
          ...data,
          date: dayjs(data.date),
        });

        setIsLoading(false);
      }
    } catch {
      setIsLoading(false);
    }
  }, [id, form]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { isLoading, customerId, initialValues, setCustomerId };
};
